import { jsx as _jsx } from "react/jsx-runtime";
import { ExternalLinks } from '../../common/constants/constants';
import NotRegisteredNotice from './not-registered-notice';
export default function NotRegisteredPage() {
    return (_jsx(NotRegisteredNotice, { linkHref: ExternalLinks.SUPPORT, linkMessage: "Contact our support team for more details", code: "Not registered", message: "License Vault", description: "With License Vault, you can efficiently manage the distribution and usage of JetBrains licenses within your company." }));
}
